

import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {},
})
export default class AlertTooltip extends Vue {

    @Prop({
        required: true,
        default: '',
    })
    private title!: string;

}
